import { i18n } from '@/i18n.ts';
import { formatCurrency } from './format-numbers';

export function formatVehicleExtraValue(
  type: string | null | undefined,
  value?: string | number | null,
  fallback = '',
): string {
  if (!type) {
    return fallback;
  }
  const raw = value == null ? '' : String(value);
  const numeric = Number(raw);
  const count =
    raw === 'true' ? 1 : raw === 'false' ? 0 : raw === '' || Number.isNaN(numeric) ? 1 : numeric;
  const amount = Number.isNaN(numeric) ? raw : formatCurrency(numeric);
  const valueKey = `vehicleExtraValues.${type}`;
  const translated = String(i18n.global.t(valueKey, { count, amount }));
  if (translated !== valueKey) {
    return translated;
  }
  const nameKey = `vehicleExtras.${type}`;
  const name = String(i18n.global.t(nameKey));
  return name === nameKey ? fallback || type : name;
}
